<script setup lang="ts">
import ProductCard01 from "./ProductCard01/ProductCard01.vue";
import { useRoute } from "vue-router";

const route = useRoute();

const tours = useTourStore();
const limitedTours = computed(() => {
  return route.path.startsWith("/alltour")
    ? tours.getTours
    : tours.getTours.slice(0, 12);
});
</script>
<template>
  <section class="mb-10 mt-6 w-full text-center">
    <h2 class="mb-11 text-lg font-semibold uppercase text-[#535353]">
      {{
        route.path.startsWith("/alltour")
          ? "All Bali Tour Destinations"
          : "Bali Tour Destinations"
      }}
    </h2>

    <div
      class="mx-auto mb-9 grid grid-cols-2 gap-3 px-4 md:max-w-5xl md:grid-cols-3"
    >
      <ProductCard01
        v-for="(item, index) in limitedTours"
        :key="index"
        :item="item"
      />
    </div>

    <!-- <NuxtLink to="/alltour" v-if="!route.path.startsWith('/alltour')">
      <p class="underline text-primary"
        >View all Bali tour destinations</p
      >
    </NuxtLink> -->
    <NuxtLink
      to="/alltour"
      v-if="!route.path.startsWith('/alltour')"
      class="inline-flex items-center rounded-lg bg-primary px-6 py-2 text-white transition-all duration-300 hover:bg-opacity-80 active:scale-95"
    >
      View all Bali Tour Destinations
    </NuxtLink>
  </section>
</template>
